// マイページ開設同意確認
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import axios from '../../axios';
import { handleBrowserBack } from '../../BrowserBack';
import { clauses_list } from '../../Const';
import AgreementTemplate from '../../molecules/AgreementTemplate';
import TransitionButton from '../../molecules/TransitionButton';
import Annotation from '../../atoms/Annotation';
import LoadingModal from '../../molecules/LoadingModal';

interface Clauses {
  heading: string;
  types: number[];
  main_btn_label: string;
  sub_btn_label: string;
  leave_text: string;
  sub_btn_area: JSX.Element | undefined;
}

const AgreementApplicant: React.FC = () => {
  // URLパラメータ取得
  const url_params = new URLSearchParams(document.location.search.substring(1));
  const jacode = url_params.get('jacode');
  const r_cd = url_params.get('r_cd');
  const r_id = url_params.get('r_id');

  // 画面構成
  const [clauses, setClauses] = useState<Clauses>(clauses_list[0]);
  // 同意文の件名、本文のstate
  const [agreement_text, setAgreementText] = useState([]);
  // ローディング画面表示状態
  const [is_loading, setIsLoading] = useState(true);

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
    fetchLists();
    createButtonArea();
  }, []);

  // 同意文の取得
  const fetchLists = async () => {
    try {
      const response = await axios.get(`${location.origin}${process.env.MIX_MOCK_URL}/get_agreement_mypage_opening`);
      if (response.data.result) {
        setAgreementText(response.data.clause);
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error(error);
      alert('システムエラーが発生しました');
    } finally {
      setIsLoading(false);
    }
  };

  // 画面下部中央のボタンを押下した時
  const mainButtonClick = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/register_applicant`, {
        ja_code: jacode,
        clauses_id_list: [agreement_text[0]['id']],
      });

      // 画面遷移
      location.replace(response.data);
    } catch (error) {
      console.error(error);
      alert('システムエラーが発生しました');
    } finally {
      setIsLoading(false);
    }
  };

  // 画面左下のボタンを押下した時
  const subButtonClick = () => {
    setIsLoading(true);
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/reception/${r_cd}/${r_id}/2000`;
  };

  // 画面左下にボタン表示かクローズ要求メッセージを表示させる判定
  const createButtonArea = () => {
    if (r_cd && r_id) {
      setClauses({
        ...clauses,
        sub_btn_area: (
          <TransitionButton label={clauses.sub_btn_label} handleClick={subButtonClick} />
        ),
      });
    } else {
      setClauses({ ...clauses, sub_btn_area: <Annotation text={clauses.leave_text} /> });
    }
  };

  return (
    <>
      <AgreementTemplate
        agreement_text={agreement_text}
        clauses={clauses}
        main_btn_func={() => mainButtonClick()}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

if (document.getElementById('agreement-applicant')) {
  render(<AgreementApplicant />, document.getElementById('agreement-applicant'));
}
